import { Flex, Text, Button, Divider } from '@shared/components';

import {
  RenderTopicCollapsible,
  type RenderTopicCollapsibleProps,
} from '../render-topic-collapsible';

export interface TopicSelectorProps extends RenderTopicCollapsibleProps {
  onEdit: () => void;
  isSomeTopicSelected: boolean;
}

export default function TopicSelector(props: Readonly<TopicSelectorProps>) {
  const { onEdit, isSomeTopicSelected, location, levelItemsWithLevel } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
      })}
    >
      <Flex
        sx={{
          justifyContent: 'space-between',
          p: (theme) => theme.spacing(3, 4),
          alignItems: 'center',
        }}
      >
        <Text variant='body1Semibold'>หัวข้อที่เลือก</Text>
        <Button variant='outlined' size='small' onClick={onEdit}>
          <Text variant='body2Semibold'>{isSomeTopicSelected ? 'Edit Topic' : 'Select Topic'}</Text>
        </Button>
      </Flex>
      <Divider />
      {isSomeTopicSelected ? (
        <Flex
          sx={{
            p: (theme) => theme.spacing(4),
            flexDirection: 'column',
            gap: (theme) => theme.spacing(4),
          }}
        >
          <RenderTopicCollapsible location={location} levelItemsWithLevel={levelItemsWithLevel} />
        </Flex>
      ) : (
        <Text sx={{ p: (theme) => theme.spacing(4), textAlign: 'center' }}>
          ไม่มีหัวข้อที่เลือก
        </Text>
      )}
    </Flex>
  );
}
